import { Component, h, Prop, Element, Fragment } from '@stencil/core';

export type SocialNetwork = 'facebook' | 'twitter' | 'linkedin' | 'email' | 'pinterest' | 'website';
export type SocialShareOptions = Record<SocialNetwork, string>;

@Component({
  tag: 'hd-social-share',
  styleUrl: 'hd-social-share.pcss',
  shadow: true
})
export class HdSocialShare {
  @Prop({ reflect: true, mutable: true }) open: boolean = false;
  @Prop({ reflect: true }) socialShareOptions: SocialShareOptions | null = null;
  @Prop() alignPosition: 'left' | 'right' = 'right';
  @Element() hostElement: HTMLElement;


  componentDidLoad() {
    document.addEventListener('click', this.handleClickOutside);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  copyLink = (e) => {
    const btnToCopy = e.target;
    navigator.clipboard.writeText(window.location.href);
    btnToCopy.innerHTML = btnToCopy.getAttribute('data-text-copied')
    setTimeout(function () {
      btnToCopy.innerHTML = btnToCopy.getAttribute('data-text-copy')
    }, 3000)
  }

  private handleClickOutside = (event: MouseEvent) => {
    if (this.open && !this.hostElement.contains(event.target as Node)) {
      this.open = false;
    }
  };

  render() {
    return (
      <div class="container">
        <button class="trigger-btn" onClick={() => this.open = !this.open}>
          <span>Share</span>
        </button>
        {this.open && (
          <div class={`dropdown-content ${this.alignPosition}`}>
            <button class="close-btn" onClick={() => this.open = false}>
              <hd-icon svg="cancel" width="12" height="12"></hd-icon>
            </button>
            <h4 class="title">Share this profile</h4>
            {this.socialShareOptions &&
              <Fragment>
                <div class="social-share-options">
                  {Object.entries(this.socialShareOptions).map(([network, value]) => {
                    return (
                      <a class="social-share-option" href={value}
                        target="_blank" rel="noopener noreferrer">
                        <hd-icon svg={network} width="30" height="30" circle />
                        <span>{network}</span>
                      </a>
                    )
                  })}
                </div>
                <div class="divider"><span>or</span></div>
              </Fragment>
            }
            <hd-button primary padded data-text-copied="URL copied" data-text-copy="Copy URL"
              onClick={this.copyLink}>
              Copy URL
            </hd-button>
          </div>
        )}
      </div>
    );
  }
}
